import React from 'react';
import { Link } from 'react-router-dom';
import { Album } from '../Album.interface';
import './SingleAlbumPreview.css';

const singleAlbumPreview = (props: { album: Album }) => {
  const album = props.album;
  const song = album && album.songs && album.songs[0];
  const hasLyrics = !!song && !!song.lyrics;
  const hasLink = !!song && !!song.mp3
  return (
    <div className="album">
      <Link to={'/diskografie/' + album.name}>
        <img className="album-cover" src={album.cover} alt={'Cover alba ' + album.name} />
      </Link>
      <div className="album-details">
        <div>
          <p>Název: <b>{album.name}</b></p>
          <p>Rok vydání alba: {album.released}</p>
        </div>
        <div className="album-team">
          <Link to={'/diskografie/' + album.name}>&rarr; Otevřít detaily alba<br />
            {album.interprets ? <p>• podílející se členy</p> : null}
            {hasLyrics ? <p>• texty písní</p> : null}
            {hasLink ? <p>• mp3 ke stažení</p> : null}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default singleAlbumPreview;